var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1471,
    viewBox: "0 0 1471 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#title_svg__filter0_d_547_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.464 24.954v30.318h48.005v15.657H30.464v38.146H12V9.439h72.576v15.515H30.464zM159.385 9.44h18.463v99.635h-18.463V9.439zM281.86 25.096h-32.95V9.44h84.364v15.657h-32.95v83.979H281.86V25.096z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.309 67.354L422.544 83.58v25.479H404.08V9.423h18.464v51.099l49.141-51.099h20.736l-41.756 44.551 44.313 55.085H473.39l-35.081-41.705zM607.339 110.482c-10.131 0-19.268-2.183-27.411-6.548-8.143-4.46-14.534-10.58-19.174-18.36-4.639-7.877-6.959-16.654-6.959-26.333 0-9.679 2.32-18.409 6.959-26.19 4.64-7.876 11.031-13.996 19.174-18.361 8.143-4.46 17.28-6.69 27.411-6.69 10.132 0 19.269 2.23 27.412 6.69 8.143 4.365 14.534 10.438 19.173 18.219 4.64 7.78 6.96 16.558 6.96 26.332 0 9.774-2.32 18.551-6.96 26.332-4.639 7.781-11.03 13.902-19.173 18.361-8.143 4.365-17.28 6.548-27.412 6.548zm0-16.226c6.628 0 12.593-1.471 17.896-4.413 5.302-3.036 9.468-7.212 12.498-12.525 3.03-5.41 4.545-11.435 4.545-18.077 0-6.642-1.515-12.62-4.545-17.934-3.03-5.41-7.196-9.584-12.498-12.526-5.303-3.036-11.268-4.555-17.896-4.555s-12.593 1.519-17.895 4.555c-5.303 2.942-9.469 7.117-12.499 12.526-3.03 5.313-4.545 11.292-4.545 17.934 0 6.642 1.515 12.668 4.545 18.077 3.03 5.314 7.196 9.489 12.499 12.525 5.302 2.942 11.267 4.413 17.895 4.413zM825.749 9.423v99.636h-15.197l-54.823-67.468v67.468h-18.321V9.423h15.197l54.822 67.468V9.423h18.322zM997.683 9.423v99.636h-15.197l-54.822-67.468v67.468h-18.322V9.423h15.197l54.823 67.468V9.423h18.321zM1155.84 93.544v15.515h-74.56V9.423h72.57v15.515h-54.11v25.905h48.01v15.23h-48.01v27.47h56.1zM1267.61 67.354l-15.77 16.226v25.479h-18.46V9.423h18.46v51.099l49.14-51.099h20.74l-41.76 44.551 44.31 55.085h-21.58l-35.08-41.705zM1407.59 25.08h-32.95V9.423H1459V25.08h-32.95v83.979h-18.46V25.08z",
    fill: "#E84444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "title_svg__filter0_d_547_241",
    x: 0,
    y: 0,
    width: 1471,
    height: 126.482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_547_241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_547_241",
    result: "shape"
  })))));
}
export default SvgTitle;